// Identificadores canónicos de los tabs del DashboardReports. Estos strings son
// el contrato compartido entre: (a) el `TAB_REGISTRY` de DashboardReports.vue
// (qué componente montar + fallback), (b) el `ROW_TO_TAB` de ResultadosTab.vue
// (navegación cross-tab desde el P&L) y (c) el `data-theme="X"` de cada tab
// hijo. La navegación VISIBLE de los tabs vive en el sidebar
// (`components/layout/navConfig.js`). Centralizar los ids acá evita typos
// silenciosos entre esos lugares.
export const TAB_IDS = Object.freeze({
    DASHBOARD: "dashboard",
    RESULTADOS: "resultados",
    VENTAS: "ventas",
    COSTOS: "costos",
    GASTOS: "gastos",
    RENTABILIDAD: "rentabilidad",
    NO_OPER: "no_oper",
    ACTIVOS: "activos",
    KPIS: "kpis",
    // Balance (aún sin vista propia → ComingSoon en el registry).
    BALANCE_RESUMEN: "balance_resumen",
    PASIVOS: "pasivos",
    PATRIMONIO: "patrimonio",
    // Proyecciones Financieras (grupo propio en el sidebar, sección
    // "proyecciones"; tabs aún ComingSoon).
    PRESUPUESTO: "presupuesto",
    PROYECCION_CAJA: "proyeccion_caja",
});
